<template>
  <div class="sf-row">
    <div
      class="tw-px-3 tw-max-w-full tw-overflow-y-auto"
      :style="{
        maxHeight: forSidebar
          ? `calc(100vh - var(--sticky-header-height) - var(--system-banner-height) - var(--main-subheader-height) - 195px)`
          : '378px',
      }"
    >
      <div
        v-if="entries.length === 0"
        class="sf-alignc sf-c-text sf-bg-snow-dark sf-font-l sf-pad-4 sf-dim-el"
      >
        {{ I18n.t('permanent_document.modal_select.empty_folder') }}
      </div>
      <div
        v-else
        class="
          tw-rounded-lg
          tw-overflow-hidden
          tw-border-solid
          tw-border
          tw-border-sf-neutral-lighter-2
        "
      >
        <table
          class="
            sf-table sf-table-border sf-table-middle
            tw-table-fixed tw-shadow-none
          "
        >
          <thead>
            <tr>
              <th class="!tw-px-4 !tw-py-3 !tw-border-none tw-w-8" />
              <th class="!tw-px-4 !tw-py-3 !tw-border-none">
                {{
                  I18n.t('components.document.existing_docs_modal.export_name')
                }}
              </th>
              <th class="!tw-px-4 !tw-py-3 !tw-border-none">
                {{ I18n.t('components.document.existing_docs_modal.author') }}
              </th>
              <th
                class="!tw-px-4 !tw-py-3 !tw-border-none tw-whitespace-nowrap"
              >
                {{
                  I18n.t('components.document.existing_docs_modal.exported_at')
                }}
              </th>
              <th
                class="!tw-px-4 !tw-py-3 !tw-border-none tw-w-12 tw-min-w-12"
              />
            </tr>
          </thead>
          <tbody>
            <ExportsTableRow
              v-for="entry in entries"
              :key="entry.id"
              :selected="selectedEntriesIds.includes(entry.id)"
              :entry="entry"
              @toggle-selection="emit('toggleSelection', entry)"
            />
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import ExportsTableRow from '@app/application/reconciliation/sections/exports-table-row.vue'
import type { ExportType } from '@app/application/export/types'
import useI18n from '@app/shared/vue/composables/use-I18n'

interface Props {
  entries: ExportType[]
  selectedEntriesIds: number[]
  forSidebar: boolean
}

defineProps<Props>()

const emit = defineEmits<{ toggleSelection: [ExportType] }>()

const I18n = useI18n()
</script>
